import { choiceLabels } from '@efdigital/ll-addon-content/helpers/choice-for';
import {
  type Answer,
  type Quiz,
  type QuizQuestion,
  QuizQuestionType,
} from '@efdigital/ll-addon-data';

/** Questions worth showing a respondent — no hidden or meta fields. */
export function answeredQuestions(quiz: Quiz): QuizQuestion[] {
  return quiz.questions.filter(
    (question) =>
      question.type !== QuizQuestionType.Hidden &&
      question.type !== QuizQuestionType.Meta
  );
}

/** Display value for a question, resolving choice labels where relevant. */
export function answerDisplayValue(
  question: QuizQuestion,
  answer: Answer
): string {
  const value = answer.values.find(
    (answerValue) => answerValue.qid === question.qid
  )?.value;

  const labels = choiceLabels(question, value);
  if (labels.length) {
    return labels.join(', ');
  }

  return typeof value === 'string' && value.length ? value : 'Not answered';
}

/**
 * The onboarding quiz always opens with Industry, Seniority, and two
 * Language preference questions, in that fixed order — everything after is
 * shown as a card series. There's nothing in the question data itself
 * (qid/title) that marks these four as special, so position is the only
 * signal available.
 */
export type OnboardingQuestionLayout = {
  industry?: QuizQuestion;
  seniority?: QuizQuestion;
  languagePreferences: QuizQuestion[];
  remaining: QuizQuestion[];
};

export function onboardingQuestionLayout(quiz: Quiz): OnboardingQuestionLayout {
  const [industry, seniority, language1, language2, ...remaining] =
    answeredQuestions(quiz);

  return {
    industry,
    seniority,
    languagePreferences: [language1, language2].filter(
      (question): question is QuizQuestion => Boolean(question)
    ),
    remaining,
  };
}
